const getOr = require('lodash/fp/getOr');

const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common/api-factory');
const serviceFactory = require('../resources/assets-common/service-factory');
const routeAdderFactory = require('../resources/assets-common/route-adder-factory');
const parsePosition = require('../resources/assets-common/parse-position');
const merge = require('lodash/fp/merge');

function parseBondsPosition(position) {
  const p = path => getOr(null, path, position);

  return merge(
    parsePosition(position),
    {
      accruedInterest: p('psAccIntRefCcy'),
      rating: p('shownRating') != null && p('shownRatingAgency') != null ? p('shownRating') + ' / ' + p('shownRatingAgency') : null,
    }
  );
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/bonds/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    assetCategory: '5',
    positionsUrl: 'bonds-positions',
    transactionsUrl: 'bonds-transactions',
    valueMovementUrl: 'bonds-value-movement',
  });

  const service = serviceFactory({
    api,
    parsePosition: parseBondsPosition,
  });

  return routeAdderFactory({ assetType: 'bonds', service });
}

module.exports = addRoutes;

